import { infiniteQueryOptions } from '@tanstack/react-query';
import api from '../services/api';

export interface User {
  userId: string;
}

interface GetUsersResponse {
  page: number;
  availablePages: number;
  totalSize: number;
  items?: User[];
}

interface GetUsersParams {
  page: number;
  pageSize: number;
  search?: string;
}

const PAGE_SIZE = 50;

export const getUsers = async (idToken: string, schema: string, { page, pageSize, search }: GetUsersParams) => {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    fields: 'userId',
    sort: 'userId',
    logicalOperator: 'AND',
  });

  params.append('filter', 'archived:eq:false');
  params.append('filter', 'loginRequired:eq:true');
  params.append('filter', 'groups:id:is_blank:false');
  params.append('filter', 'userId:is_blank:false');

  if (search) {
    params.append('filter', `userId:like:${search}`);
  }

  const endpoint = `users?${params.toString()}`;

  return api<GetUsersResponse>(endpoint, {
    headers: {
      authorization: `Bearer ${idToken}`,
      'myosh-schema': schema,
    },
  });
};

export const usersInfiniteQueryOptions = (idToken: string, schema: string | undefined, search: string) =>
  infiniteQueryOptions({
    // Interactive picker: surface failures immediately so the UI can show an error instead of
    // silently retrying (a 401 from a stale token would never succeed anyway).
    retry: false,
    queryKey: ['login-control-users', schema, search.trim()],
    queryFn: ({ pageParam }) =>
      getUsers(idToken, schema as string, { page: pageParam, pageSize: PAGE_SIZE, search: search.trim() || undefined }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => (lastPage.page < lastPage.availablePages ? lastPage.page + 1 : undefined),
  });
